class StickyATCBar {
  constructor() {
    this.sectionId = document.querySelector('product-info')?.dataset.section;
    if (!this.sectionId) {
      console.log('[STICKY-ATC] ERROR: product-info element not found');
      return;
    }
    
    this.stickyBar = document.getElementById(`sticky-atc-bar-${this.sectionId}`);
    this.productForm = document.querySelector('so-product-form') || 
                       document.querySelector('product-form') || 
                       document.querySelector('.product-form');
    this.productFormButtons = document.querySelector('.product-form__buttons');
    this.variantModal = document.getElementById(`StickyVariantModal-${this.sectionId}`);
    
    if (!this.stickyBar) {
      console.log('[STICKY-ATC] ERROR: Sticky bar not found');
      return;
    }

    if (!this.productForm && !this.productFormButtons) {
      console.log('[STICKY-ATC] ERROR: Product form not found');
      return;
    }
    
    this.init();
  }

  init() {
    this.setupScrollListener();
    this.setupVariantChangeListener();
    this.setupStickyButtons();
    this.setupModalButtons();
  }

  setupScrollListener() {
    const checkVisibility = () => {
      // Try to find the actual submit button instead of the wrapper
      let targetElement = document.querySelector('.product-form__submit[type="submit"]');
      
      // Fallback to product-form__buttons if submit not found
      if (!targetElement || targetElement.offsetHeight === 0) {
        targetElement = document.querySelector('.product-form__buttons');
      }
      
      // Another fallback to the entire product form
      if (!targetElement || targetElement.offsetHeight === 0) {
        targetElement = document.querySelector('product-form, .product-form');
      }
      
      if (!targetElement) {
        console.log('[STICKY-ATC] ERROR: No suitable target element found');
        return;
      }

      const rect = targetElement.getBoundingClientRect();
      const scrollY = window.scrollY || window.pageYOffset;
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      const isMobile = window.innerWidth <= 749;
      
      // Check if element is partially visible in viewport
      const isPartiallyVisible = (
        rect.top < viewportHeight &&
        rect.bottom > 0 &&
        rect.left < (window.innerWidth || document.documentElement.clientWidth) &&
        rect.right > 0
      );
      
      // On mobile, also check if user has scrolled down at least 300px
      const hasScrolledEnough = isMobile ? scrollY > 300 : true;
      
      // Show sticky when button is NOT visible in viewport AND user has scrolled enough (mobile only)
      const shouldShowSticky = !isPartiallyVisible && hasScrolledEnough;
      
      // Show sticky when button is not visible
      if (shouldShowSticky) {
        this.stickyBar.style.display = 'block';
        this.updateStickyBarFromDOM();
      } else {
        this.stickyBar.style.display = 'none';
      }
    };

    // Check on scroll with throttle
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          checkVisibility();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Check on resize
    window.addEventListener('resize', () => {
      checkVisibility();
    });
    
    // Initial check after DOM is ready
    setTimeout(() => {
      checkVisibility();
    }, 200);

    // Check again after images load
    window.addEventListener('load', () => {
      checkVisibility();
    });
  }

  setupVariantChangeListener() {
    // Listen to variant changes from the main product form
    document.addEventListener('variant:change', (event) => {
      this.updateStickyBarFromDOM();
    });

    // Listen to changes on variant inputs/selects directly
    const variantInputs = document.querySelectorAll('variant-selects input, variant-radios input, variant-selects select, variant-radios select');
    variantInputs.forEach(input => {
      input.addEventListener('change', () => {
        setTimeout(() => {
          this.updateStickyBarFromDOM();
        }, 150);
      });
    });

    // Listen to price updates
    const priceElement = document.querySelector(`#price-${this.sectionId}`);
    if (priceElement) {
      const priceObserver = new MutationObserver(() => {
        this.updateStickyPrice();
      });

      priceObserver.observe(priceElement, {
        childList: true,
        subtree: true
      });
    }

    // Initial update
    setTimeout(() => {
      this.updateStickyBarFromDOM();
    }, 400);
  }

  updateStickyPrice() {
    const stickyPrice = document.getElementById(`sticky-product-price-${this.sectionId}`);
    const mainPrice = document.querySelector(`#price-${this.sectionId}`);
    
    if (stickyPrice && mainPrice) {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }
  }

  updateStickyBarFromDOM() {
    
    // Update image from main product
    const mainProductImage = document.querySelector('.product__media-item:not(.is-active) img, .product__media-item img');
    const activeMediaItem = document.querySelector('.product__media-item.is-active img') || mainProductImage;
    const stickyImage = document.getElementById(`sticky-product-image-${this.sectionId}`);
    
    if (stickyImage && activeMediaItem) {
      const imgSrc = activeMediaItem.src.split('?')[0];
      stickyImage.src = imgSrc;
    }

    // Update variant title
    const variantPicker = document.querySelector('variant-selects, variant-radios');
    const stickyVariant = document.getElementById(`sticky-product-variant-${this.sectionId}`);
    
    if (stickyVariant && variantPicker) {
      const selectedValues = [];
      const radioInputs = variantPicker.querySelectorAll('input[type="radio"]:checked');
      const selectInputs = variantPicker.querySelectorAll('select');
      
      radioInputs.forEach(input => {
        selectedValues.push(input.value);
      });
      
      selectInputs.forEach(select => {
        if (select.value) {
          selectedValues.push(select.value);
        }
      });
      
      if (selectedValues.length > 0) {
        stickyVariant.textContent = selectedValues.join(' / ');
        stickyVariant.style.display = 'block';
      } else {
        stickyVariant.textContent = '';
        stickyVariant.style.display = 'none';
      }
    }

    // Update price
    const stickyPrice = document.getElementById(`sticky-product-price-${this.sectionId}`);
    const mainPrice = document.querySelector(`#price-${this.sectionId}`);
    
    if (stickyPrice && mainPrice) {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }

    // Update ATC button state (both sticky bar and modal)
    const stickyAtcButton = document.getElementById(`sticky-atc-button-${this.sectionId}`);
    const modalAtcButton = document.getElementById(`sticky-modal-atc-button-${this.sectionId}`);
    const mainAtcButton = document.querySelector('.product-form__submit[type="submit"][name="add"]');
    
    if (mainAtcButton) {
      const isDisabled = mainAtcButton.disabled || mainAtcButton.hasAttribute('disabled');
      const mainButtonText = mainAtcButton.querySelector('span');
      
      // Update sticky bar button
      if (stickyAtcButton) {
        stickyAtcButton.disabled = isDisabled;
        const buttonText = stickyAtcButton.querySelector('span');
        if (buttonText && mainButtonText) {
          buttonText.textContent = mainButtonText.textContent;
        }
        if (!isDisabled) {
          stickyAtcButton.removeAttribute('disabled');
        }
      }
      
      // Update modal button
      if (modalAtcButton) {
        modalAtcButton.disabled = isDisabled;
        const buttonText = modalAtcButton.querySelector('span');
        if (buttonText && mainButtonText) {
          // Remove arrow for modal button
          buttonText.textContent = mainButtonText.textContent.replace(' ➜', '');
        }
        if (!isDisabled) {
          modalAtcButton.removeAttribute('disabled');
        }
      }
    }
  }

  getCurrentVariant() {
    const productInfo = document.querySelector('product-info');
    if (!productInfo) return null;

    const variantInput = productInfo.querySelector('input[name="id"]');
    if (!variantInput) return null;

    const variantId = variantInput.value;
    const productData = JSON.parse(
      document.querySelector(`script[data-product-json]`)?.textContent || '{}'
    );

    return productData.variants?.find(v => v.id == variantId);
  }

  updateStickyBar(variant) {
    if (!variant) return;

    // Update image
    const stickyImage = document.getElementById(`sticky-product-image-${this.sectionId}`);
    if (stickyImage && variant.featured_media) {
      const imgUrl = variant.featured_media.preview_image.src.replace(/\.(jpg|png|gif|webp)/i, '_80x80.$1');
      stickyImage.src = imgUrl;
    }

    // Update variant title
    const stickyVariant = document.getElementById(`sticky-product-variant-${this.sectionId}`);
    if (stickyVariant) {
      if (variant.title && variant.title !== 'Default Title') {
        stickyVariant.textContent = variant.title;
        stickyVariant.style.display = 'block';
      } else {
        stickyVariant.textContent = '';
        stickyVariant.style.display = 'none';
      }
    }

    // Update price
    const stickyPrice = document.getElementById(`sticky-product-price-${this.sectionId}`);
    const mainPrice = document.querySelector(`#price-${this.sectionId}`);
    if (stickyPrice && mainPrice) {
      stickyPrice.innerHTML = mainPrice.innerHTML;
    }

    // Update ATC button state (both sticky bar and modal)
    const stickyAtcButton = document.getElementById(`sticky-atc-button-${this.sectionId}`);
    const modalAtcButton = document.getElementById(`sticky-modal-atc-button-${this.sectionId}`);
    
    if (stickyAtcButton) {
      stickyAtcButton.disabled = !variant.available;
      const buttonText = stickyAtcButton.querySelector('span');
      if (buttonText) {
        buttonText.textContent = variant.available ? 'Add to cart ➜' : 'Sold out';
      }
    }
    
    if (modalAtcButton) {
      modalAtcButton.disabled = !variant.available;
      const buttonText = modalAtcButton.querySelector('span');
      if (buttonText) {
        buttonText.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }
    }
  }

  setupStickyButtons() {
    // Sticky ATC button - scrolls to variant selector
    const stickyAtcButton = document.getElementById(`sticky-atc-button-${this.sectionId}`);
    if (stickyAtcButton) {
      stickyAtcButton.addEventListener('click', async (e) => {
        e.preventDefault();
        
        // Scroll to the price item element
        const targetElement = document.querySelector('.price-item.price-item--sale.price-item--last') ||
                             document.querySelector('.price-item') ||
                             document.querySelector('.product-form__buttons') || 
                             document.querySelector('product-form');
        
        if (targetElement) {
          // Smooth scroll to the element
          targetElement.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
          
          // Optional: Add a brief highlight effect
          targetElement.style.transition = 'background-color 0.3s ease';
          const originalBg = targetElement.style.backgroundColor;
          targetElement.style.backgroundColor = 'rgba(var(--color-foreground), 0.05)';
          setTimeout(() => {
            targetElement.style.backgroundColor = originalBg;
          }, 600);
        }
      });
    }

    // Modal ATC button - triggers main form submit and closes modal
    const modalAtcButton = document.getElementById(`sticky-modal-atc-button-${this.sectionId}`);
    if (modalAtcButton) {
      modalAtcButton.addEventListener('click', async (e) => {
        e.preventDefault();
        this.submitToCart();
        // Close modal after adding to cart
        setTimeout(() => {
          this.closeModal();
        }, 100);
      });
    }
  }

  submitToCart() {
    // Try to find and click the main submit button first
    const mainSubmitButton = document.querySelector('.product-form__submit[type="submit"][name="add"]');
    
    if (mainSubmitButton && !mainSubmitButton.disabled) {
      mainSubmitButton.click();
    } else {
      // Fallback: Submit the form directly if button click doesn't work
      const productFormElement = document.querySelector('so-product-form form') || 
                                document.querySelector('product-form form') || 
                                document.querySelector('form[action*="/cart/add"]');
      
      if (productFormElement) {
        // Trigger submit event that Shopify/ShineOn listens to
        const submitEvent = new Event('submit', { 
          bubbles: true, 
          cancelable: true 
        });
        productFormElement.dispatchEvent(submitEvent);
        
        // If event wasn't prevented, submit the form
        if (!submitEvent.defaultPrevented) {
          productFormElement.submit();
        }
      }
    }
  }

  setupModalButtons() {
    if (!this.variantModal) return;

    // Save scroll position whenever modal opens (watch for 'open' attribute)
    const modalObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          if (this.variantModal.hasAttribute('open')) {
            this.scrollBeforeModal = window.scrollY || window.pageYOffset;
          }
        }
      });
    });
    
    modalObserver.observe(this.variantModal, { attributes: true });

    // Close button
    const closeButton = document.getElementById(`StickyVariantModalClose-${this.sectionId}`);
    if (closeButton) {
      closeButton.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.closeModal();
      });
    }

    // Close on backdrop click (click outside modal content)
    this.variantModal.addEventListener('click', (e) => {
      const dialogContent = this.variantModal.querySelector('.sticky-variant-modal__content');
      if (dialogContent && !dialogContent.contains(e.target)) {
        this.closeModal();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.variantModal.hasAttribute('open')) {
        this.closeModal();
      }
    });

    // Listen to variant changes in modal
    const modalContainer = document.getElementById(`sticky-variant-picker-container-${this.sectionId}`);
    if (modalContainer) {
      // Prevent form submission
      modalContainer.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
      }, true);
      
      // Prevent all anchor clicks
      modalContainer.addEventListener('click', (e) => {
        if (e.target.tagName === 'A' || e.target.closest('a')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      // Add click handler on labels to capture and sync immediately
      modalContainer.querySelectorAll('label').forEach(label => {
        label.addEventListener('click', (e) => {
          // Find input ONLY within the modal container
          const input = label.querySelector('input[type="radio"]') || 
                       modalContainer.querySelector(`#${label.getAttribute('for')}`);
          
          if (input && input.type === 'radio') {
            // FORCE uncheck all other radio inputs in this fieldset
            const fieldset = input.closest('fieldset');
            if (fieldset) {
              fieldset.querySelectorAll('input[type="radio"]').forEach(inp => {
                if (inp !== input) {
                  inp.checked = false;
                  // Remove active class from its label - search ONLY in this fieldset
                  const siblingLabel = fieldset.querySelector(`label[for="${inp.id}"]`);
                  if (siblingLabel) {
                    siblingLabel.classList.remove('active');
                  }
                }
              });
            }
            
            // FORCE check the clicked input
            input.checked = true;
            
            // Add active class to the label - search ONLY in this fieldset
            const clickedLabel = fieldset?.querySelector(`label[for="${input.id}"]`);
            if (clickedLabel) {
              clickedLabel.classList.add('active');
            }
            
            setTimeout(() => {
              if (input.checked) {
                this.handleVariantChange(input);
              }
            }, 50);
          }
        }, false);
      });
      
      // Backup: Also listen to input clicks directly
      modalContainer.querySelectorAll('input[type="radio"]').forEach(input => {
        input.addEventListener('click', (e) => {
          // FORCE uncheck siblings
          const fieldset = input.closest('fieldset');
          if (fieldset) {
            fieldset.querySelectorAll('input[type="radio"]').forEach(inp => {
              if (inp !== e.target) {
                inp.checked = false;
                // Remove active class
                const siblingLabel = fieldset.querySelector(`label[for="${inp.id}"]`);
                if (siblingLabel) {
                  siblingLabel.classList.remove('active');
                }
              }
            });
          }
          
          // FORCE check this one
          e.target.checked = true;
          
          // Add active class
          const clickedLabel = fieldset?.querySelector(`label[for="${e.target.id}"]`);
          if (clickedLabel) {
            clickedLabel.classList.add('active');
          }
          
          setTimeout(() => {
            if (e.target.checked) {
              this.handleVariantChange(e.target);
            }
          }, 50);
        });
      });

      // When a variant option changes in the modal
      modalContainer.addEventListener('change', (e) => {
        if (e.target.type !== 'radio' && e.target.tagName !== 'SELECT') return;
        
        // FORCE uncheck siblings
        const fieldset = e.target.closest('fieldset');
        if (fieldset) {
          fieldset.querySelectorAll('input[type="radio"]').forEach(inp => {
            if (inp !== e.target) {
              inp.checked = false;
              // Remove active class
              const siblingLabel = fieldset.querySelector(`label[for="${inp.id}"]`);
              if (siblingLabel) {
                siblingLabel.classList.remove('active');
              }
            }
          });
        }
        
        // FORCE check the changed input
        e.target.checked = true;
        
        // Add active class
        const changedLabel = fieldset?.querySelector(`label[for="${e.target.id}"]`);
        if (changedLabel) {
          changedLabel.classList.add('active');
        }
        
        this.handleVariantChange(e.target);
      });
    }
  }

  handleVariantChange(input) {
    const modalInputValue = input.value;
    const modalFieldsetElement = input.closest('fieldset');
    
    // Prevent scroll changes
    const currentScrollY = window.scrollY || window.pageYOffset;
    const savedScrollY = this.scrollBeforeModal || currentScrollY;
    
    if (window.scrollY !== savedScrollY) {
      window.scrollTo(0, savedScrollY);
    }
    
    // Sync with main form
    const mainVariantPicker = document.querySelector(`#ProductInfo-${this.sectionId} variant-selects, #ProductInfo-${this.sectionId} variant-radios`);
    
    if (mainVariantPicker && modalFieldsetElement) {
      const legend = modalFieldsetElement.querySelector('legend');
      const optionName = legend?.textContent.trim().replace(':', '').split('\n')[0].trim();
      
      const mainFieldsets = mainVariantPicker.querySelectorAll('fieldset');
      
      mainFieldsets.forEach(mainFieldset => {
        const mainLegend = mainFieldset.querySelector('legend');
        if (mainLegend && mainLegend.textContent.includes(optionName)) {
          const mainInput = mainFieldset.querySelector(`input[value="${modalInputValue}"], option[value="${modalInputValue}"]`);
          
          if (mainInput) {
            if (mainInput.tagName === 'INPUT') {
              mainInput.checked = true;
              mainInput.dispatchEvent(new Event('change', { bubbles: true }));
            } else if (mainInput.tagName === 'OPTION') {
              mainInput.selected = true;
              mainInput.closest('select').dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });
    }
    
    // Restore scroll position again after DOM updates
    window.scrollTo(0, savedScrollY);
    
    // Check if all variant options are selected before closing modal
    const modalVariantPicker = this.variantModal.querySelector('variant-selects, variant-radios');
    if (modalVariantPicker) {
      const allFieldsets = modalVariantPicker.querySelectorAll('fieldset');
      let allSelected = true;
      
      allFieldsets.forEach(fieldset => {
        const hasCheckedRadio = fieldset.querySelector('input[type="radio"]:checked');
        const hasSelectedOption = fieldset.querySelector('select option:checked');
        
        if (!hasCheckedRadio && !hasSelectedOption) {
          allSelected = false;
        }
      });
      
      // Only close modal if all options are selected OR there's only one option
      if (allSelected || allFieldsets.length === 1) {
        this.closeModal(savedScrollY);
        
        // Update sticky bar after closing
        setTimeout(() => {
          this.updateStickyBarFromDOM();
        }, 50);
      } else {
        // Keep scroll position locked
        window.scrollTo(0, savedScrollY);
        // Update sticky bar without closing
        setTimeout(() => {
          this.updateStickyBarFromDOM();
        }, 50);
      }
    } else {
      // No variant picker found, close modal as before
      this.closeModal(savedScrollY);
      
      // Update sticky bar after closing
      setTimeout(() => {
        this.updateStickyBarFromDOM();
      }, 50);
    }
  }

  openModal() {
    if (this.variantModal) {
      // Save scroll position when opening modal
      this.scrollBeforeModal = window.scrollY || window.pageYOffset;
      
      const modalContainer = document.getElementById(`sticky-variant-picker-container-${this.sectionId}`);
      if (modalContainer) {
        // Only remove active classes from labels - DON'T touch input checked states
        const allModalLabels = modalContainer.querySelectorAll('label');
        allModalLabels.forEach(label => {
          label.classList.remove('active');
        });
        
        // Find the main variant-selects (NOT in modal)
        const allVariantSelects = document.querySelectorAll('variant-selects');
        let mainVariantSelects = null;
        
        // Find the one that's NOT inside the modal
        allVariantSelects.forEach(vs => {
          if (!vs.closest('dialog') && !vs.closest('.sticky-variant-modal')) {
            mainVariantSelects = vs;
          }
        });
        
        if (mainVariantSelects) {
          const mainSelects = mainVariantSelects.querySelectorAll('input[type="radio"]:checked');
          
          // The inputs are already synced (they're the same DOM elements!)
          // We just need to add the active class to the corresponding labels in the modal
          mainSelects.forEach(mainInput => {
            // Find the label in the MODAL for this input
            const modalLabel = modalContainer.querySelector(`label[for="${mainInput.id}"]`);
            if (modalLabel) {
              modalLabel.classList.add('active');
            }
          });
        }
        
        // Now add active class to checked inputs
        const checkedInputs = modalContainer.querySelectorAll('input[type="radio"]:checked');
        checkedInputs.forEach(input => {
          const fieldset = input.closest('fieldset');
          const label = fieldset?.querySelector(`label[for="${input.id}"]`);
          if (label) {
            label.classList.add('active');
          }
        });
      }
      
      // Use native modal API if available, otherwise use custom implementation
      if (typeof this.variantModal.showModal === 'function') {
        this.variantModal.showModal();
      } else if (this.variantModal.show) {
        this.variantModal.show();
      } else {
        this.variantModal.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
      }

      // Add active class AFTER modal is fully opened (in case something resets the HTML)
      setTimeout(() => {
        if (modalContainer) {
          const checkedInputs = modalContainer.querySelectorAll('input[type="radio"]:checked');
          checkedInputs.forEach(input => {
            const fieldset = input.closest('fieldset');
            const label = fieldset?.querySelector(`label[for="${input.id}"]`);
            if (label) {
              label.classList.add('active');
            }
          });
        }
      }, 50);
    }
  }

  closeModal(savedScrollY = null) {
    if (this.variantModal) {
      // Use provided scroll position or the one saved when modal opened
      const scrollY = savedScrollY !== null ? savedScrollY : (this.scrollBeforeModal || window.scrollY);
      
      // Use native modal API if available
      if (typeof this.variantModal.close === 'function') {
        this.variantModal.close();
      } else if (this.variantModal.hide) {
        this.variantModal.hide();
      } else {
        this.variantModal.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
      }
      
      // Restore scroll position multiple times to override any Shopify behavior
      if (scrollY > 0) {
        // Create a persistent restoration function
        const restoreScroll = () => {
          if (window.scrollY !== scrollY) {
            window.scrollTo(0, scrollY);
          }
        };
        
        // Restore immediately
        restoreScroll();
        
        // Use requestAnimationFrame for next frame
        requestAnimationFrame(() => {
          restoreScroll();
        });
        
        // Multiple timeouts to catch any delayed Shopify scripts
        [10, 50, 100, 200, 300, 400].forEach(delay => {
          setTimeout(() => {
            restoreScroll();
          }, delay);
        });
      }
      
      // Clear saved scroll
      this.scrollBeforeModal = null;
    }
  }

  syncModalWithMainForm() {
    const mainVariantPicker = document.querySelector(`#ProductInfo-${this.sectionId} variant-selects, #ProductInfo-${this.sectionId} variant-radios`);
    const modalContainer = document.getElementById(`sticky-variant-picker-container-${this.sectionId}`);
    
    if (!mainVariantPicker || !modalContainer) return;
    
    // First, remove ALL active-variant classes from ALL labels (not just ones with the class)
    modalContainer.querySelectorAll('label').forEach(l => {
      if (l.classList.contains('active-variant')) {
        l.classList.remove('active-variant');
        console.log('[STICKY-ATC] Removed active-variant from:', l.textContent.trim().substring(0, 30));
      }
    });

    // Get all selected options from main form
    const selectedInputs = mainVariantPicker.querySelectorAll('input[type="radio"]:checked');
    console.log('[STICKY-ATC] Found', selectedInputs.length, 'checked inputs in main form');
    
    selectedInputs.forEach((input) => {
      const value = input.value;
      const fieldset = input.closest('fieldset');
      
      if (fieldset && value) {
        const legend = fieldset.querySelector('legend');
        const optionName = legend?.textContent.trim().replace(':', '').split('\n')[0].trim();
        
        console.log('[STICKY-ATC] Syncing option:', optionName, '=', value);
        
        // Find corresponding fieldset in modal
        const modalFieldsets = modalContainer.querySelectorAll('fieldset');
        modalFieldsets.forEach(modalFieldset => {
          const modalLegend = modalFieldset.querySelector('legend');
          if (modalLegend && modalLegend.textContent.includes(optionName)) {
            const modalInput = modalFieldset.querySelector(`input[value="${value}"]`);
            if (modalInput) {
              modalInput.checked = true;
              // Add active class to the corresponding label
              const label = modalFieldset.querySelector(`label[for="${modalInput.id}"]`);
              console.log('[STICKY-ATC] Found modal input:', modalInput.id, 'checked:', modalInput.checked);
              if (label) {
                label.classList.add('active-variant');
                console.log('[STICKY-ATC] ✅ Added active-variant to:', label.textContent.trim().substring(0, 30));
              } else {
                console.log('[STICKY-ATC] ❌ Label not found for input:', modalInput.id);
              }
            }
          }
        });
      }
    });
    
    // Final check
    const activeLabels = modalContainer.querySelectorAll('label.active-variant');
    console.log('[STICKY-ATC] Total active-variant labels after sync:', activeLabels.length);
    activeLabels.forEach(l => console.log('  -', l.textContent.trim()));
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initStickyBar();
  });
} else {
  initStickyBar();
}

// Function to initialize with proper timing
async function initStickyBar() {
  // Wait for so-product-form OR product-form custom element to be defined
  if (customElements) {
    try {
      // Check which custom element is used
      const hasSoProductForm = document.querySelector('so-product-form');
      const elementName = hasSoProductForm ? 'so-product-form' : 'product-form';
      
      await Promise.race([
        customElements.whenDefined(elementName),
        new Promise(resolve => setTimeout(resolve, 3000)) // Max 3 seconds wait
      ]);
    } catch (e) {
      // Ignore error
    }
  }
  
  // Wait for the product-form element to be in the DOM and ready
  const waitForProductForm = () => {
    return new Promise((resolve) => {
      const checkForm = () => {
        const productForm = document.querySelector('so-product-form') || 
                           document.querySelector('product-form');
        const form = productForm?.querySelector('form');
        
        if (productForm && form) {
          resolve();
        } else {
          setTimeout(checkForm, 50);
        }
      };
      checkForm();
    });
  };
  
  await Promise.race([
    waitForProductForm(),
    new Promise(resolve => setTimeout(resolve, 3000)) // Max 3 seconds wait
  ]);
  
  // Additional small delay to ensure all event listeners are attached
  setTimeout(() => {
    new StickyATCBar();
  }, 150);
}

// Re-initialize on Shopify section re-render
document.addEventListener('shopify:section:load', () => {
  initStickyBar();
});
